module.exports = __webpack_public_path__ + "img/Pot3.e19e8b85.svg";